import { ConfirmationModalComponent } from '$core/modal/confirmation-modal/confirmation-modal.component';
import { DefaultObject } from '$core/models/default-object';
import { TrackInfo } from '$core/models/track';
import { AuthenticationService } from '$core/services/auth.service';
import { SwalService } from '$core/shell/swal/swal.service';
import { HttpErrorResponse } from '@angular/common/http';
import {
  Directive,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { faChevronDown, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { first } from 'rxjs/operators';
import { CrudBaseComponent } from './_crud.service';

@Directive()
export abstract class PersonalItemBaseDirective<T extends DefaultObject> {
  public model: any = TrackInfo;
  public manageModal: any;
  @Input() public item: T;
  @Output() public saveItem = new EventEmitter();
  @Output() public deleteItem = new EventEmitter();
  @Output() public deleteFromObjItem = new EventEmitter();

  public readonly type: string = 'TRACK';
  public readonly faTrashAlt = faTrashAlt;
  public readonly faChevronDown = faChevronDown;
  public isCollapsed = true;
  public savedItem: T;

  @ViewChild('element', { static: false }) protected _element;

  public get nativeElement() {
    return this._element.nativeElement;
  }

  constructor(
    public authService: AuthenticationService,
    protected requestService: CrudBaseComponent,
    protected modalService: BsModalService,
    protected swalService: SwalService,
    protected translates: TranslateService
  ) {}

  public toggleCollapsed(item: T) {
    this.isCollapsed = !this.isCollapsed;
    // this.getItem(item);
  }

  public onDeleteItem(item: T) {
    this.modalService.show(ConfirmationModalComponent, {
      class: 'modal-dialog-centered',
      initialState: {
        title: `DELETE_${this.type}_CONFIRMATION_QUESTION`,
        declineBtn: 'CANCEL',
      },
    });
    this.modalService.onHidden.pipe(first()).subscribe((res) => {
      if (res === 'confirm') {
        this.delete(item);
      }
    });
  }

  public onSaveItem() {}

  public updateItem() {
    const m = this.modalService.show(this.manageModal, {
      initialState: {
        item: new this.model(this.item),
      },
      class: 'modal-lg modal-dialog-centered',
    });
    this.modalService.onHidden.pipe(first()).subscribe((res) => {
      if (res === 'saved' && m.content && m.content.item) {
        this.item.update(m.content.item);
        this.saveItem.next(this.item);
      }
    });
  }

  protected async getItem(body) {
    try {
      const item = new this.model(
        await this.requestService.getItems(body).toPromise()
      );
    } catch (error) {
      this.onError(error);
    }
  }

  protected async delete(item: T) {
    try {
      await this.requestService.deleteItem(item.id).toPromise();
      this.deleteItem.next(item);
    } catch (error) {
      this.onError(error);
    }
  }

  protected onError(error) {
    const res: HttpErrorResponse = error;
    const swal = this.swalService.swal;
    swal.icon = 'error';
    swal.title = this.translates.instant('AN_ERROR_HAS_OCCURRED');
    if (res.status === 404) {
      swal.text = this.translates.instant(
        res.error.message || `${this.type}_CODE_NOT_FOUND`
      );
      swal.fire();
    } else {
      swal.text = res.error
        ? res.error.message || res.error.error
        : res.statusText;
      swal.fire();
    }
  }
}
